module.exports = [
	{
		"name": "Card Swipe Safes",
		"modelThumb": "card-swipe-safes.png",
		"modelType": "modelOnly",
		"modelNumberLocation": [
			{
				"x": "220",
				"y": "120",
				"tooltip": "On the hinge, by the door"
			}
		]
	},
	{
		"name": "Chest & File Safes",
		"modelThumb": "chest-and-file-safes.png",
		"modelType": "modelAndSerialChestFile",
		"modelNumberLocation": [
			{
				"x": "142",
				"y": "174",
				"tooltip": "Bottom of unit."
			}
		],
		"serialNumberLocation": [
			{
				"x": "135",
				"y": "125",
				"tooltip": "Inside cover"
			}
		]
	},
	{
		"name": "Commercial Safes",
		"modelThumb": "commercial-safes.png",
		"modelType": "modelOnly",
		"modelNumberLocation": [
			{
				"x": "178",
				"y": "194",
				"tooltip": "Near the hinge by the door, under SentrySafe logo, or on the side"
			}
		]
	},
	{
		"name": "Depository Safes",
		"modelThumb": "depository-safes.png",
		"modelType": "modelOnly",
		"modelNumberLocation": [
			{
				"x": "50",
				"y": "175",
				"tooltip": "Left or right side of the unit, near the back"
			}
		]
	},
	{
		"name": "Electronic Security Boxes",
		"modelThumb": "electronic-security-boxes.png",
		"modelType": "modelOnly",
		"modelNumberLocation": [
			{
				"x": "63",
				"y": "188",
				"tooltip": "Bottom of unit"
			}
		]
	},
	{
		"name": "Executive Digital Fire Safe",
		"modelThumb": "executive-digital-fire-safe.png",
		"modelType": "modelOnly",
		"modelNumberLocation": [
			{
				"x": "160",
				"y": "45",
				"tooltip": "Back wall, upper corner"
			},
			{
				"x": "186",
				"y": "178",
				"tooltip": "Right outside wall, lower corner"
			}
		]
	},
	{
		"name": "Fire Safes",
		"modelThumb": "fire-safes.png",
		"modelType": "modelAndSerial",
		"modelNumberLocation": [
			{
				"x": "187",
				"y": "172",
				"tooltip": "Front, next to hinge"
			}
		],
		"serialNumberLocation": [
			{
				"x": "187",
				"y": "172",
				"tooltip": "Lower right hand corner of safe door"
			},
			{
				"x": "145",
				"y": "110",
				"tooltip": "Bottom lip of keypad/faceplate"
			},
			{
				"x": "77",
				"y": "164",
				"tooltip": "Inside right corner of front door"
			}
		]
	},
	{
		"name": "Fire Safes With USB Port",
		"modelThumb": "fire-safes-with-usb.png",
		"modelType": "modelAndSerial",
		"modelNumberLocation": [
			{
				"x": "167",
				"y": "180",
				"tooltip": "Front of safe, next to hinge"
			}
		],
		"serialNumberLocation": [
			{
				"x": "77",
				"y": "194",
				"tooltip": "Bottom of product"
			}
		]
	},
	{
		"name": "Floor Safes",
		"modelThumb": "floor-safes.png",
		"modelType": "modelAndSerial",
		"modelNumberLocation": [
			{
				"x": "143",
				"y": "16",
				"tooltip": "On side of handle"
			}
		],
		"serialNumberLocation": [
			{
				"x": "143",
				"y": "16",
				"tooltip": "On handle"
			}
		]
	},
	{
		"name": "Gun Safes",
		"modelThumb": "gun-safes.png",
		"modelType": "modelAndSerial",
		"modelNumberLocation": [
			{
				"x": "78",
				"y": "9",
				"tooltip": "On the back, near top corner"
			}
		],
		"serialNumberLocation": [
			{
				"x": "146",
				"y": "204",
				"tooltip": "Right outside wall on lower corner"
			},
			{
				"x": "81",
				"y": "30",
				"tooltip": "Back outside wall on upper corner"
			},
			{
				"x": "122",
				"y": "72",
				"tooltip": "Peel off center sticker to reveal number on back"
			}
		]
	},
	{
		"name": "Gun Safes Electronic Lock",
		"modelThumb": "gun-safes-electronic-lock.png",
		"modelType": "modelAndSerial",
		"modelNumberLocation": [
			{
				"x": "78",
				"y": "9",
				"tooltip": "On the back, near top corner"
			}
		],
		"serialNumberLocation": [
			{
				"x": "150",
				"y": "200",
				"tooltip": "Right outside wall on lower corner"
			},
			{
				"x": "80",
				"y": "15",
				"tooltip": "Back outside wall on upper corner"
			},
			{
				"x": "142",
				"y": "63",
				"tooltip": "Behind keypad battery pack (override key # located here)"
			}
		]
	},
	{
		"name": "Home Defense Center",
		"modelThumb": "home-defense-center.png",
		"modelType": "modelOnly",
		"modelNumberLocation": [
			{
				"x": "117",
				"y": "20",
				"tooltip": "Under the battery cover"
			},
			{
				"x": "117",
				"y": "216",
				"tooltip": "Bottom front of the unit"
			}
		]
	},
	{
		"name": "Pistol & Drawer Safes",
		"modelThumb": "pistol-and-drawer-safes.png",
		"modelType": "modelOnly",
		"modelNumberLocation": [
			{
				"x": "170",
				"y": "67",
				"tooltip": "On the back"
			}
		]
	},
	{
		"name": "T-Line Security Safes",
		"modelThumb": "t-line-safes.png",
		"modelType": "modelOnly",
		"modelNumberLocation": [
			{
				"x": "150",
				"y": "28",
				"tooltip": "Right side, near the back"
			}
		]
	},
	{
		"name": "V-Line Safes",
		"modelThumb": "v-line-safes.png",
		"modelType": "modelAndSerial",
		"modelNumberLocation": [
			{
				"x": "208",
				"y": "130",
				"tooltip": "Right side or on the back"
			}
		],
		"serialNumberLocation": [
			{
				"x": "206",
				"y": "140",
				"tooltip": "Right outside wall on lower corner"
			},
			{
				"x": "175",
				"y": "122",
				"tooltip": "Original key (minus leading letter)"
			},
			{
				"x": "142",
				"y": "142",
				"tooltip": "Peel off venter sticker for number on back"
			}
		]
	},
	{
		"name": "Wall Safes",
		"modelThumb": "wall-safes.png",
		"modelType": "modelAndSerial",
		"modelNumberLocation": [
			{
				"x": "173",
				"y": "173",
				"tooltip": "Lower right corner below door"
			}
		],
		"serialNumberLocation": [
			{
				"x": "173",
				"y": "173",
				"tooltip": "Lower right corner below door"
			}
		]
	},
	{
		"name": "X-Line Safes",
		"modelThumb": "x-line-safes.png",
		"modelType": "modelOnly",
		"modelNumberLocation": [
			{
				"x": "213",
				"y": "160",
				"tooltip": "Right side, near the back"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/support/findModelSerialNumber/modelAndSerialData.json
// module id = 691
// module chunks = 0